import { Severity } from '@/shared/constants/serviceStatus/Severity'

/**
 * getStatusLabelHashMap: Returns a hash map of all the available status labels
 * @returns
 */
const getStatusLabelHashMap = function() {
  const map = new Map()

  map.set(Severity.HEALTHY, {
    title: Severity.HEALTHY,
    color: 'success',
    icon: 'mdi-check-circle-outline',
  })
  map.set(Severity.DEGRADED, {
    title: Severity.DEGRADED,
    color: 'warning',
    icon: 'mdi-alert-circle-outline',
  })
  map.set(Severity.UNHEALTHY, {
    title: Severity.UNHEALTHY,
    color: 'error',
    icon: 'mdi-alert-circle-outline',
  })
  map.set(Severity.ADVISORY, {
    title: Severity.ADVISORY,
    color: 'info',
    icon: 'mdi-information-outline',
  })

  return map
}

export { getStatusLabelHashMap }
